export default "/_next/static/chunks/fonts/Channel4Chadwick-ExtraLight-39225b812741d97d9ed03e7cca8238ff.woff";